module.exports = __webpack_public_path__ + "static/img/29.3f7917c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/29.jpg
// module id = x4o0
// module chunks = 1